const menu = document.querySelector('.menu');
const menuOverlay = document.querySelector('.menu-overlay');
const burger = document.querySelector('.header__burger');

function openMenu() {
  if (!menu || !menuOverlay || !burger) return;

  menu.classList.add('active');
  menuOverlay.classList.add('active');
  document.body.classList.add('no-scroll');
  burger.classList.add('active');
  burger.setAttribute('aria-expanded', 'true');
  burger.setAttribute('aria-label', 'Закрыть меню');
  menuOverlay.setAttribute('aria-hidden', 'false');
}

function openMenuFunc() {
  if (!burger) return;

    if (burger.classList.contains('active')) closeMenu();
    else openMenu();
}

function closeMenu() {
  if (!menu || !menuOverlay || !burger) return;

  menu.classList.remove('active');
  menuOverlay.classList.remove('active');
  document.body.classList.remove('no-scroll');
  burger.classList.remove('active');
  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-label', 'Открыть меню');
  menuOverlay.setAttribute('aria-hidden', 'true');
}

burger?.addEventListener('click', openMenuFunc);

if (menuOverlay) {
  menuOverlay.addEventListener('click', (event) => {
    if (event.target === menuOverlay) closeMenu();
  });

  menuOverlay.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && burger?.classList.contains('active')) {
    closeMenu();
    burger.focus();
  }
});
